export default [
  {
    path: '/clinician-dashboard',
    name: 'clinician-dashboard',
    component: () => import('@/views/DashboardClinician.vue'),
    meta: {
      protected: true,
      printQueueUserBlocked: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
]
